import { Base } from "@studiometa/js-toolkit";
import { domScheduler } from "@studiometa/js-toolkit/utils";
class Editors extends Base {
  /**
   * Config.
   */
  static config = {
    name: "Editors"
  };
  hide() {
    domScheduler.write(() => {
      this.$el.classList.add("hidden");
    });
  }
  show() {
    domScheduler.write(() => {
      this.$el.classList.remove("hidden");
    });
  }
}
export {
  Editors as default
};
//# sourceMappingURL=Editors.js.map
